import HomePage from '../Dashboard/HomePage/HomePage';

// Corporate Routes
import AboutUs from '../Dashboard/Corporate/aboutus';
import CoreValue from '../Dashboard/Corporate/corevalue';
import VisionMission from '../Dashboard/Corporate/vision_mission';
import SocialResponsibility from '../Dashboard/Corporate/social_responsibility';
import Location from '../Dashboard/Corporate/location';
import IndiaLocation from '../Dashboard/Corporate/location_india';
import MalaysiaLocation from '../Dashboard/Corporate/location_malasiya';
import Teams from '../Dashboard/Corporate/team';

// Solution Routes
import ApplicationMiddleware from '../Dashboard/Solutions/applicationMiddleware';
import BigData from '../Dashboard/Solutions/bigData';
import BusinessIntelligence from '../Dashboard/Solutions/businessIntelligence';
import DataManagement from '../Dashboard/Solutions/dataManagement';
import EnterpriseData from '../Dashboard/Solutions/enterprisedata';

// Products Routes
import LogMode from '../Dashboard/Products/logmode';

// Industries Routes
import FinancialServices from '../Dashboard/Industries/financialServices';
import Government from '../Dashboard/Industries/government';
import Manufacturing from '../Dashboard/Industries/manufacturing';
import Retail from '../Dashboard/Industries/retail';
import Telecommunications from '../Dashboard/Industries/telecommunication';
import Utilities from '../Dashboard/Industries/utilities';

// Service Routes
import B2BMobileApps from '../Dashboard/Services/EnterpriseMobilityService/b2bMobile';
import BusinessProcess from '../Dashboard/Services/EnterpriseMobilityService/businessProcess';
import EnterpriseAndroidApp from '../Dashboard/Services/EnterpriseMobilityService/enterpriseAndroidApp';
import EnterpriseApp from '../Dashboard/Services/EnterpriseMobilityService/enterpriseApp';
import EnterpriseIOSApp from '../Dashboard/Services/EnterpriseMobilityService/enterpriseIosApp';
import MobileBusiness from '../Dashboard/Services/EnterpriseMobilityService/mobileBusiness';

import BusinessIntelligenceService from '../Dashboard/Services/BusinessIntelligenceService/BusinessIntelligenceService';

import AndroidApp from '../Dashboard/Services/MobileApps/androidApp';
import BlackberryApp from '../Dashboard/Services/MobileApps/blackberryApp';
import IphoneApp from '../Dashboard/Services/MobileApps/iphoneApp';
import Windows8App from '../Dashboard/Services/MobileApps/windows8app';

import AutomatedTesting from '../Dashboard/Services/Testing&QA/automatedTesting';
import ManualTesting from '../Dashboard/Services/Testing&QA/manualTesting';
import QTP from '../Dashboard/Services/Testing&QA/qtp';
import Selenium from '../Dashboard/Services/Testing&QA/selenium';
import TestComplete from '../Dashboard/Services/Testing&QA/testComplete';

import CRMApplication from '../Dashboard/Services/WebApplication/cmrApplication';
import ContentManagement from '../Dashboard/Services/WebApplication/contentManagement';
import CustomWebApp from '../Dashboard/Services/WebApplication/customWebApp';
import InventoryManagement from '../Dashboard/Services/WebApplication/inventoryManagement';
import OpenSource from '../Dashboard/Services/WebApplication/openSource';

import PrivacyPolicy from '../Dashboard/PrivacyPolicy/PrivacyPolicy';
import TermsOfUse from '../Dashboard/TermsConditions/TermsConditions';
import EnquiryForm from '../Dashboard/EnquiryForm/EnquiryForm';

const DefaultRoutes = [
    { path: '/', element: <HomePage /> },

    // Corporate Routes
    { path: '/aboutus', element: <AboutUs /> },
    { path: '/core-value', element: <CoreValue /> },
    { path: '/vision-mission', element: <VisionMission /> },
    { path: '/social-responsibility', element: <SocialResponsibility /> },
    {
        path: '/location',
        element: <Location />,
        children: [
            { path: 'india', element: <IndiaLocation /> },
            { path: 'malaysia', element: <MalaysiaLocation /> }
        ]
    },
    { path: '/teams', element: <Teams /> },

    // Solution Routes
    { path: '/application-middleware-management', element: <ApplicationMiddleware /> },
    { path: '/big-data-and-advanced-analytics', element: <BigData /> },
    { path: '/business-intelligence-solutions', element: <BusinessIntelligence /> },
    { path: '/data-management', element: <DataManagement /> },
    { path: '/enterprise-data-warehouse', element: <EnterpriseData /> },

    // Products Routes
    { path: '/log-mode', element: <LogMode /> },

    // Industries Routes
    { path: '/financial-services', element: <FinancialServices /> },
    { path: '/government', element: <Government /> },
    { path: '/manufacturing', element: <Manufacturing /> },
    { path: '/retail', element: <Retail /> },
    { path: '/telecommunications', element: <Telecommunications /> },
    { path: '/utilities', element: <Utilities /> },

    // Service Routes

    // Enterprise Mobility Service
    { path: '/enterprise-mobility-service/B2B-mobile-apps', element: <B2BMobileApps /> },
    { path: '/enterprise-mobility-service/business-process', element: <BusinessProcess /> },
    { path: '/enterprise-mobility-service/enterprise-android-app', element: <EnterpriseAndroidApp /> },
    { path: '/enterprise-mobility-service/enterprise-app', element: <EnterpriseApp /> },
    { path: '/enterprise-mobility-service/enterprise-ios-app', element: <EnterpriseIOSApp /> },
    { path: '/enterprise-mobility-service/mobile-business', element: <MobileBusiness /> },

    // Business Intelligence Service
    { path: '/business-intelligence-service', element: <BusinessIntelligenceService /> },

    // Mobile Apps Development
    { path: '/mobile-apps-development/android-app-development', element: <AndroidApp /> },
    { path: '/mobile-apps-development/blackberry-app-development', element: <BlackberryApp /> },
    { path: '/mobile-apps-development/Iphone-app-development', element: <IphoneApp /> },
    { path: '/mobile-apps-development/windows8-app-development', element: <Windows8App /> },

    // Testing and QA Services
    { path: '/testing-QA-services/automated-testing', element: <AutomatedTesting /> },
    { path: '/testing-QA-services/manual-testing', element: <ManualTesting /> },
    { path: '/testing-QA-services/qtp', element: <QTP /> },
    { path: '/testing-QA-services/selenium', element: <Selenium /> },
    { path: '/testing-QA-services/test-complete', element: <TestComplete /> },

    // Web Application Development
    { path: '/web-application-development/CRM-application', element: <CRMApplication /> },
    { path: '/web-application-development/content-management', element: <ContentManagement /> },
    { path: '/web-application-development/custom-web-app', element: <CustomWebApp /> },
    { path: '/web-application-development/inventory-management', element: <InventoryManagement /> },
    { path: '/web-application-development/open-source', element: <OpenSource /> },

    { path: '/privacy-policy', element: <PrivacyPolicy /> },
    { path: '/terms-of-use', element: <TermsOfUse /> },
    { path: '/enquiry', element: <EnquiryForm /> },
];

const RoutesConfig = { DefaultRoutes };

export { DefaultRoutes };
export default RoutesConfig;

